import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "篩檢年份",
    isNumber: true,
    isSum: true,
  },
];

export const SOFTotalScoreToCheckYear = {
  label: "SOF總分 vs 篩檢年份",
  key: "SOFTotalScoreToCheckYear",
  path: "ElderlyHealth/SOFTotalScoreToCheckYear",
  api: "TCS_V_OHCheckItems01V",
  render: (options) => (
    <Diagram.ElderlyHealth.SOFTotalScoreToCheckYear {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "SOF",
      field: "SOF",
      header: "",
      isNumber: true,
      isSkip: true,
    },
  ],
  levelColumns,
  columns: [],
};
